module.exports = __webpack_public_path__ + "img/SnatchPark_logo06.9b489ac8.png";